import { useEffect } from "react";

/** Changes the crawler directive when the SPA leaves its public landing page. */
export function useRobotsMeta(content: "index, follow" | "noindex, nofollow"): void {
  useEffect(() => {
    let meta = document.querySelector<HTMLMetaElement>('meta[name="robots"]');
    const created = meta === null;
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "robots";
      document.head.append(meta);
    }
    const previousContent = meta.content;
    meta.content = content;
    return () => {
      if (created) meta?.remove();
      else if (meta) meta.content = previousContent;
    };
  }, [content]);
}
